import api from './api';

export const workerService = {
  async getAll() {
    const response = await api.get('/users/workers/');
    return response.data.data || [];
  },

  async getById(id) {
    const response = await api.get(`/users/workers/${id}`);
    return response.data.data;
  },

  async create(formData) {
    const response = await api.post('/users/workers/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },

  async update(id, data) {
    const response = await api.put(`/users/workers/${id}`, data);
    return response.data.data;
  },

  async delete(id) {
    const response = await api.delete(`/users/workers/${id}`);
    return response.data;
  },
};
